// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__header{background:#1a243e;display:flex}.contain-item{display:flex;align-items:center;margin-bottom:20px}.j-c{justify-content:center;margin-top:60px}.item-radio{width:100px}.item-text{padding-left:40px}", ""]);
// Exports
module.exports = exports;
